import { colors } from 'theme'

export const defaultThemeStyles = {
    path: colors.darkCloud
}
